<template>
    <div class="message message-negative" v-if="hasErrors">
        <div v-if="title" class="message-title">
            <h2>{{title}}</h2>
        </div>
        <div class="message-content">
            <ul class="list">
                <template v-if="hasFrontendErrors && hasSlotContent">
                    <slot></slot>
                </template>
                <template v-if="hasApiErrors">
                    <li class="list-item"
                        v-for="(item, index) in apiErrors"
                        :key="`error-${index}`"
                    >{{item | capitalize}}</li>
                </template>
                <template v-if="hasPredicateErrors">
                    <li class="list-item"
                        v-for="(item, index) in predicateErrors"
                        :key="`predicate-${index}`"
                    >{{item.message}}</li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
    import ErrorHandler from '@/common/errors';

    export default {
        name: 'v-error-messages',
        props: {
            serverError: {
                type: Error,
                default: null,
            },
            hasFrontendErrors: {
                type: Boolean,
                default: true,
            },
            title: String,
            predicates: Array,
        },
        data() {
            return {
                hasSlotContent: false,
            };
        },
        methods: {
            checkForSlotContent() {
                const checkForContent = (hasContent, node) => hasContent || node.tag || (node.text && node.text.trim());
                return this.$slots.default && this.$slots.default.reduce(checkForContent, false);
            },
        },
        computed: {
            apiErrors() {
                return this.serverError
                    ? ErrorHandler.parseError(this.serverError)
                    : [];
            },
            hasApiErrors() {
                return this.apiErrors.length > 0;
            },
            predicateErrors() {
                return this.predicates
                    ? this.predicates.filter(p => p.predicate())
                    : [];
            },
            hasPredicateErrors() {
                return this.predicateErrors.length > 0;
            },
            hasErrors() {
                return (this.hasFrontendErrors && this.hasSlotContent)
                    || (this.hasFrontendErrors && this.hasPredicateErrors)
                    || this.hasApiErrors;
            },
        },
        beforeUpdate() {
            if (this.hasFrontendErrors) this.hasSlotContent = this.checkForSlotContent();
        },
        created() {
            if (this.hasFrontendErrors) this.hasSlotContent = this.checkForSlotContent();
        },
    };
</script>
